import React, { useContext, useEffect } from 'react'
import studyReportContext from '../../../../../context/studyreport/StudyReportContext';
import ConfirmModal from '../../../../../components/Modal/ConfirmModal';
import { useTranslation } from 'react-i18next';

const ForceReinference = (props) => {

    const { t } = useTranslation();

    const {
        
        handleSubmitReport,
        showForceReinferenceModal,
        setForReinferenceInProgress,
        setShowForceReinferenceModal,
        forceReinferenceInProgress,
        addendumDisclaimerAddedByRad,
        showAddendumDisclaimerPopup,
      } = useContext(studyReportContext);

      const handleConfirmAddendumByRad = () =>{
        setForReinferenceInProgress(false);
      }

      useEffect(() => {
        if(showForceReinferenceModal){
            setShowForceReinferenceModal(false);
            handleSubmitReport(
                false,
                props.keyImages,
                props.annotationData,
                props.annotationDataAI,
                props.allTextToolAnnotation,
                props.activeViewportIndex,
                false,
                addendumDisclaimerAddedByRad,
                showAddendumDisclaimerPopup
            );
           
        }
      },[forceReinferenceInProgress])

      const handleNotConfirmAddendumByRad = () =>{
        setShowForceReinferenceModal(false);
      }

      const handleCloseConfirmModal = () =>{
        setShowForceReinferenceModal(false);
        return;
      }
    

  return (
    <ConfirmModal handleConfirm={handleConfirmAddendumByRad} handleNotConfirm={handleNotConfirmAddendumByRad} handleCloseIcon={handleCloseConfirmModal} setShowConfirmModal={setShowForceReinferenceModal} showConfirmModal={showForceReinferenceModal} message={t("confirm-message.confirm-force-reinference-for-submit")}
          title={t("confirm-message.confirm")} confirmButtonText={t("confirm-message.yes")} cancelButtonText={t("confirm-message.no")}/>
  )
}

export default ForceReinference;